module.exports = __webpack_public_path__ + "fonts/ttnorms-light-webfont.968f41fa.woff2";